const SECONDARY_FILTERS = ["Unassigned", "Team Members"];

export default SECONDARY_FILTERS;
